<template>
  <section id="how-to-use" class="slider-block">
    <h2 class="h2">How to set up the app</h2>

    <div class="slider-wrapper">
      <div class="slider">
        <DotLottieVue
          ref="playerRef1"
          class="slide"
          :autoplay="false"
          :loop="false"
          src="/animations/slide_1.json"
        />
        <DotLottieVue
          ref="playerRef2"
          class="slide"
          :autoplay="false"
          :loop="false"
          src="/animations/slide_2.json"
        />
        <DotLottieVue
          ref="playerRef3"
          class="slide"
          :autoplay="false"
          :loop="false"
          src="/animations/slide_3.json"
        />
      </div>
    </div>

    <ul class="slider-legend">
      <li
        v-for="(slide, i) in slides"
        class="slider-legend__item"
        :key="`sl${i}`"
      >
        <div class="slide-progress">
          <div :id="'slp_' + (i + 1)" class="slide-progress__bar" />
        </div>
        <div class="slider-legend__item-title h3" v-html="slide.text" />
      </li>
    </ul>
  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue'
const playerRef1 = ref()
const playerRef2 = ref()
const playerRef3 = ref()

const slides = [
  {
    text: 'Get a VLESS key from your own<br/> server or from any VPN provider'
  },
  {
    text: 'Paste the key into<br/> the Soda app'
  },
  {
    text: 'Connect and enjoy secure<br/> internet access'
  }
]

onMounted(() => {
  const dot1 = document.getElementById('slp_1')
  const dot2 = document.getElementById('slp_2')
  const dot3 = document.getElementById('slp_3')
  const dotLottie1 = playerRef1.value.getDotLottieInstance()
  const dotLottie2 = playerRef2.value.getDotLottieInstance()
  const dotLottie3 = playerRef3.value.getDotLottieInstance()

  const dots = [dot1, dot2, dot3]
  const slides = [playerRef1, playerRef2, playerRef3]
  const dotLotties = [dotLottie1, dotLottie2, dotLottie3]

  dotLotties.forEach((player, i) => {
    const index = i < 2 ? i + 1 : 0

    if (player) {
      player.addEventListener('complete', () => {
        // console.log('Animation completed ', i + 1)

        const activeDot = document.querySelector('.slide-progress__bar.active')
        activeDot.setAttribute('style', `none`)
        activeDot.classList.remove('active')
        activeDot.closest('.slider-legend__item').classList.remove('active')

        const activeSlide = document.querySelector('.slide.active')

        if (activeSlide) {
          activeSlide.classList.remove('active')
        }

        slides[index].value.$el.classList.add('active')
        dotLotties[index].play()
      })

      player.addEventListener('play', () => {
        dots[i].classList.add('active')
        dots[i].setAttribute(
          'style',
          `transition: width ${player.duration}s linear`
        )
        dots[i].closest('.slider-legend__item').classList.add('active')
      })
    }
  })

  if (dotLottie1) {
    dotLottie1.addEventListener('load', () => {
      dotLottie1.play()
      dot1.classList.add('active')
      playerRef1.value.$el.classList.add('active')
    })
  }
})
</script>
